<template>
	<div class="col-md-12">
		<div class="card card-container">
			<img id="profile-img" src="@/assets/img/profile/no_gender.png" class="profile-img-card" />
			<div v-if="message" class="text-center">
				<div class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{ message }}</div>
				<router-link to="/login" class="btn btn-primary">Войти</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import AuthService from "../../services/auth.service";

export default {
	data() {
		return {
			successful: false,
			message: "",
		};
	},
	computed: {
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
	},
	mounted() {
		if (this.loggedIn) {
			this.$router.push("/profile");
		}
		AuthService.verifyUser(this.$route.params.code).then(
			(data) => {
				this.message = data.message;
				this.successful = true;
			},
			(error) => {
				this.message = error.response.data.message;
				this.successful = false;
			}
		);
	},
};
</script>

<style scoped>
.card-container.card {
	max-width: 350px !important;
	padding: 40px 40px;
}

.card {
	background-color: #f7f7f7;
	padding: 20px 25px 30px;
	margin: 0 auto 25px;
	margin-top: 50px;
	-moz-border-radius: 2px;
	-webkit-border-radius: 2px;
	border-radius: 2px;
	-moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
	-webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
	box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
	width: 96px;
	height: 96px;
	margin: 0 auto 10px;
	display: block;
	-moz-border-radius: 50%;
	-webkit-border-radius: 50%;
	border-radius: 50%;
}
</style>
